export default __webpack_public_path__ + "static/media/mind_relaxation.1d450925.png";